import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { Link, useSearchParams } from 'react-router-dom';
import './Photos.css';

const Photos = () => {
  const [photos, setPhotos] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();

  const page = parseInt(searchParams.get('page')) || 1;
  const sort = searchParams.get('sort') || 'alpha'; // default to alphabetical
  const pageSize = 10;

  useEffect(() => {
    const fetchData = async () => {
      const apiUrl = sort === 'date' ? `/api/photos-by-date/${page}` : `/api/photos/${page}`;
      try {
        const response = await fetch(apiUrl);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const json = await response.json();
        setPhotos(json);
      } catch (error) {
        setError(error.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [page, sort]);

  const changePage = (newPage) => {
    setSearchParams({ page: newPage, sort });
  };

  const toggleSort = () => {
    setSearchParams({ page: 1, sort: sort === 'date' ? 'alpha' : 'date' });
  };

  if (isLoading) return <Container>Loading...</Container>;
  if (error) return <Container>Error: {error}</Container>;

  return (
    <Container className="photo-gallery">
      <h1 className="text-center my-4">Photos</h1>
      <div className="text-center mb-3">
        <Button variant="outline-light" onClick={toggleSort}>
          Sort by {sort === 'date' ? 'Name' : 'Date'}
        </Button>
      </div>
      <Row xs={2} md={3} lg={5} className="g-4">
        {photos.map((photo) => (
          <Col key={photo.photos_id} md={2} className="mb-4">
            <Card className="search-card">
              <Link to={`/photos/${photo.path}`}>
                <div className="image-container">
                  <Card.Img variant="top" src={`/members/photosthumbs/${photo.path}/large.jpg`} />
                </div>
                <Card.Body>
                  <Card.Title>{photo.updatename}</Card.Title>
                  <Card.Text>{photo.modelname}</Card.Text>
                  <Card.Text className="text-muted" style={{ fontSize: '0.9em' }}>
                    Uploaded: {photo.datetoupload}
                  </Card.Text>
                </Card.Body>
              </Link>
            </Card>
          </Col>
        ))}
      </Row>
      <Row className="pagination-row">
        <Col className="d-flex justify-content-center my-4">
          <button onClick={() => changePage(page - 1)} disabled={page === 1} className="btn btn-secondary mx-2">Previous</button>
          <button onClick={() => changePage(page + 1)} disabled={photos.length < pageSize} className="btn btn-secondary mx-2">Next</button>
        </Col>
      </Row>
    </Container>
  );
};

export default Photos;
